import SortationDisplay from './SortationDisplay_v2';

export default SortationDisplay;
